export default "__VITE_ASSET__22db5785__"